module.exports = __webpack_public_path__ + "img/btn_auto_spin.505464f9.png";